document.addEventListener('DOMContentLoaded', function () {
    // Get all checkboxes with data-shop-unique-id attribute
    const checkboxes = document.querySelectorAll('input[type="checkbox"][data-shop-unique-id]');
    // Array to store data-json of checked items
    let selectedItems = [];

    const bulkOrderButtonWrap = document.querySelector('#dropshipping-order-button-wrap');
    if (!bulkOrderButtonWrap){
        return;
    }

    const bulkOrderButton = bulkOrderButtonWrap.querySelector('button');

    // Function to update checkbox states
    function updateCheckboxes() {
        const checkedCheckbox = document.querySelector('input[type="checkbox"][data-shop-unique-id]:checked');

        if (checkedCheckbox) {
            const selectedShopId = checkedCheckbox.getAttribute('data-shop-unique-id');

            checkboxes.forEach(checkbox => {
                const shopId = checkbox.getAttribute('data-shop-unique-id');
                // Disable checkboxes with different shop IDs
                if (shopId !== selectedShopId) {
                    checkbox.disabled = true;
                }
            });
        } else {
            // If no checkbox is checked, enable all
            checkboxes.forEach(checkbox => {
                checkbox.disabled = false;
            });
        }
    }

    // Function to update selected items array
    function updateSelectedItems() {
        selectedItems = [];

        checkboxes.forEach(checkbox => {
            if (checkbox.checked) {
                const parentElement = checkbox.closest('.d-flex');
                const addNewBasket = parentElement.previousElementSibling;
                if (addNewBasket && addNewBasket.classList.contains('addNewBasket')) {
                    const jsonData = JSON.parse(addNewBasket.getAttribute('data-json'));
                    selectedItems.push(jsonData);
                }
            }
        });

        bulkOrderButtonWrap.hidden = !selectedItems.length;

        console.log('Selected items:', selectedItems); // For debugging, you can modify this
    }

    // Add event listeners to all checkboxes
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            updateCheckboxes();
            updateSelectedItems();
        });
    });

    if (bulkOrderButton){
        bulkOrderButton.addEventListener('click', function () {
            const url = this.dataset.href;
            $.ajax({
                type: "POST",
                url: url,
                dataType: "json",
                data: {items: selectedItems},
                success: function(data) {
                    if (data.url) {
                        location.href = data.url;
                        // window.open(data.url, '_blank').focus();
                    } else {
                        toastr.error(data.message);
                    }
                },
                error: function(data) {
                    toastr.error(data.responseJSON.message);
                }
            });
        });
    }

    // Initial state update
    updateCheckboxes();
    updateSelectedItems();
});
